var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalOceanContainer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2395ED;}\r\n\t.st1{fill:#0480FB;}\r\n\t.st2{fill:#2D8CEE;}\r\n\t.st3{fill:#1D1E1F;}\r\n\t.st4{fill:#222324;}\r\n\t.st5{fill:#0983FB;}\r\n\t.st6{fill:#2895E8;}\r\n\t.st7{fill:#2798EC;}\r\n\t.st8{fill:#2597ED;}\r\n\t.st9{fill:#83BAF2;}\r\n\t.st10{fill:#5F88A6;}\r\n\t.st11{fill:#6A98B7;}\r\n\t.st12{fill:#F0F9F9;}\r\n\t.st13{fill:#E9F7F8;}\r\n\t.st14{fill:#F7FBFB;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.8,53.9c-1.5-1.8-2.1-3.8-2.4-6c-0.1-0.7-0.1-1.5-0.2-2.2c0-1,0.3-1.3,1.3-1.3c5,0,10,0,15,0 c2.2,0,4.5,0,6.7,0c0.8,0,1.6-0.1,2.4-0.4c0.3-0.1,0.4-0.2,0.2-0.6c-1-2-0.5-3.8,0.6-5.5c0.2-0.3,0.3-0.3,0.6-0.1 c1.2,0.8,2.1,1.8,2.5,3.2c0.1,0.4,0.2,0.5,0.6,0.4c1-0.1,2-0.1,3,0.3c0.4,0.1,0.7,0.3,0.9,0.6c-0.2,0.3-0.4,0.6-0.4,1c0,0,0,0,0,0 c-0.2,0.1-0.3,0.2-0.2,0.4c0,0,0,0,0,0c-0.2,0-0.2,0.1-0.2,0.3c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c0,0,0,0,0,0c-0.4,0.1-0.7,0.4-1,0.7l0,0c-0.2,0-0.4,0-0.5,0.2c0,0,0,0,0,0c-0.6,0-1.1,0.2-1.7,0.3c-0.3,0.1-0.7-0.1-1,0.2 c0,0.4-0.2,0.8-0.4,1.2c-0.8,1.5-1.4,3.1-2.6,4.3c-0.1,0-0.2,0.1-0.2,0.3c0,0,0,0,0,0c-0.2,0-0.3,0.2-0.3,0.4c0,0,0,0.1-0.1,0.1 c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0c-0.5,0.2-0.8,0.5-1,1c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0.1 c0,0,0,0,0,0c-0.5,0.1-0.9,0.4-1.1,0.9l0,0c-0.2,0-0.4,0-0.4,0.2l0,0c-0.2,0-0.4,0.1-0.6,0.2c-1.9,1.1-3.9,1.8-6.1,2.2 c-2.7,0.4-5.4,0.4-8.1-0.2c-0.8-0.2-1.6-0.6-2.4-0.7c0,0,0,0,0,0c-0.1-0.2-0.2-0.2-0.4-0.1c0,0,0,0,0,0c0-0.2-0.2-0.2-0.4-0.2 c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0 c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0-0.1-0.1-0.2-0.3-0.2c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0-0.2-0.1-0.2-0.3-0.3 c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0C88.9,54,88.8,53.9,88.8,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10,47.1c0.1-3.7,1.8-6.5,4.9-8.3c4-2.3,9-1.6,12.1,1.7c3,3.2,3.4,8.2,1,12.1c-0.1,0-0.1,0.1-0.1,0.1 c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.1,0-0.2,0.1-0.1,0.2c0,0,0,0,0,0c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0 c-0.1,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.2,0-0.3,0.1-0.3,0.3c0,0,0,0,0,0c-0.2,0-0.3,0.2-0.4,0.4c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0.1 c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.4,0.4c0,0,0,0,0,0c-0.2,0-0.3,0.1-0.4,0.2c0,0,0,0,0,0 c-0.1,0-0.1,0-0.1,0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.2,0.1c0,0,0,0,0,0c-0.1,0-0.1,0-0.1,0.1l0,0c-0.3,0-0.5,0.1-0.6,0.4c0,0,0,0,0,0 c-0.2,0-0.3,0.1-0.5,0.2c-1.4,0.7-2.8,1-4.3,1c0,0,0-0.1,0-0.1c0,0,0,0,0,0c0,0,0-0.1,0-0.1c0-1.1,0-2.3,0-3.4c0,0,0-0.1,0-0.1 c0,0,0-0.1,0-0.1l0,0c0.1,0,0.1,0.1,0.2,0.1c0.2,0,0.5,0,0.7-0.1c0.1,0,0.2,0,0.3-0.1c0.3,0,0.5-0.1,0.7-0.2c4-1.6,5.3-5.6,3-9.4 c0-0.2-0.1-0.3-0.3-0.3l0,0c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.1c0-0.1,0-0.1-0.1-0.1l0,0c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.1c0,0,0,0,0,0 c0-0.1,0-0.1-0.1-0.1c0,0,0,0,0,0c0-0.2-0.1-0.2-0.3-0.2l0,0c0,0,0,0,0,0c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0 c-0.1-0.2-0.3-0.3-0.5-0.4c-1.3-0.7-2.7-1-4.1-0.8c-0.9,0.1-1.9,0.4-2.6,1.2c0,0,0,0,0,0c-0.2,0-0.4,0.1-0.4,0.3c0,0,0,0,0,0 c-0.1,0-0.2,0-0.2,0.2c0,0,0,0,0,0c-0.2,0.1-0.3,0.2-0.4,0.4l0,0c0,0,0,0,0,0c-0.3,0.1-0.4,0.2-0.4,0.5c0,0,0,0,0,0 c-0.2,0.1-0.3,0.3-0.3,0.5c0,0,0,0,0,0c-0.3,0-0.3,0.3-0.4,0.4c-0.3,0.7-0.5,1.4-0.6,2.1c0,0.3-0.1,0.4-0.4,0.4 C12.1,47.1,11.1,47.1,10,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M58.6,47.2C58.6,47.2,58.6,47.2,58.6,47.2c-0.1,0.1-0.1,0.2-0.1,0.3c0,0,0,0,0,0c-0.2,0-0.2,0.1-0.2,0.3 c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.8,0.5-1.6,0.6-2.5,0.4C55,48,54.7,47.5,54.5,47c-0.1-0.2-0.1-0.4-0.3-0.4 c-0.6,0-1.1-0.2-1.6-0.6c0,1.2,0,2.3,0,3.4c0,0.6,0.4,1,0.9,1.3c0.6,0.4,0.8,0.3,1.2-0.3c0.5-1,1.6-1.5,2.7-1.2 c1.1,0.3,1.7,1.3,1.5,2.6c-0.2,0.3-0.4,0.5-0.4,0.9c0,0,0,0,0,0c-0.9,0.7-1.8,1.1-3,0.6c0,0,0,0,0,0c0-0.1-0.1-0.1-0.2-0.1 c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c-0.3-0.8-0.9-1.1-1.7-1.4 c-0.9-0.4-1.4-1.2-1.4-2.2c0-1.3,0-2.6,0-3.9c0-0.4-0.1-0.6-0.5-0.8c-1.3-0.5-2-1.6-2-3c0-1.4,0.7-2.4,1.9-2.9 c1.3-0.5,2.5-0.3,3.5,0.6c0.9,0.9,1.2,1.9,0.9,3.2c-0.3,1.3-1.2,2-2.4,2.3c-0.2,0-0.5,0-0.5,0.2c-0.1,0.3,0.2,0.4,0.3,0.6 c0.2,0.3,0.6,0.4,0.9,0.5c0.3,0.1,0.5,0,0.7-0.4c0.4-1,1.1-1.5,2.1-1.5c1,0,1.8,0.5,2.1,1.5c0.2,0.5,0.5,0.4,0.8,0.4 c0.3,0,0.6,0,0.7-0.4c0.4-1.1,1.5-1.7,2.6-1.5c1.1,0.2,1.8,1.2,1.7,2.4c-0.2,0.2-0.1,0.4-0.1,0.6c0,0,0,0,0,0 c-0.1,0.1-0.1,0.1-0.1,0.3c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.2,0-0.3,0.2-0.3,0.4c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1 c0,0,0,0,0,0c-0.8,0.5-1.7,0.6-2.6,0.3c0,0,0,0,0,0c0-0.1-0.1-0.1-0.2-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0 c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0c0,0-0.1-0.1-0.1-0.1c-0.3-0.2-0.3-0.6-0.5-0.9 C59.3,46.1,58.8,46.4,58.6,47.2z M52.5,38.9c-1.4,0-2.6,1.1-2.6,2.5c0,1.4,1.1,2.5,2.5,2.6c1.4,0,2.6-1.1,2.6-2.5 C55,40.1,53.9,39,52.5,38.9z M56.6,49.8c-0.9,0-1.6,0.7-1.6,1.6c0,0.8,0.7,1.5,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6 C58.2,50.5,57.5,49.8,56.6,49.8z M55,46.3c0,0.9,0.7,1.6,1.6,1.6c0.9,0,1.6-0.7,1.6-1.6c0-0.9-0.7-1.6-1.6-1.6 C55.8,44.7,55,45.4,55,46.3z M62.4,44.7c-0.9,0-1.6,0.6-1.6,1.5c0,0.9,0.7,1.6,1.5,1.6c0.9,0,1.6-0.7,1.6-1.5 C64,45.4,63.3,44.7,62.4,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.2,49.1c0-0.6,0-1.1,0-1.7c0-0.5-0.2-0.6-0.6-0.6c-1.1,0-2.2,0-3.3,0c-0.4,0-0.5-0.1-0.5-0.5c0-1,0-1,0.9-1 c1,0,2,0,3.1,0c0.3,0,0.5-0.1,0.4-0.4c0-1.2,0-2.4,0-3.7c0-0.4,0.1-0.5,0.5-0.5c1,0,1,0,1,1c0,1,0,2.1,0,3.1c0,0.4,0.1,0.5,0.6,0.5 c1.1,0,2.3,0,3.4,0c0.4,0,0.5,0.1,0.5,0.5c0,1,0,1-0.9,1c-0.9,0-1.9,0-2.8,0c-0.6,0-0.8,0.1-0.7,0.7c0.1,1.1,0,2.3,0,3.4 c0,0.4-0.1,0.5-0.5,0.5c-1,0-1,0-1-1C39.2,50,39.2,49.6,39.2,49.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M74.4,41c0,0,0-0.1,0-0.1c0.2,0,0.3,0,0.5,0c0.8,0,0.8,0,0.8,0.8c0,1,0,2.1,0,3.1c0,0.2-0.1,0.5,0.2,0.5 c1.3,0,2.6,0,3.9,0c0.4,0,0.5,0.1,0.5,0.5c0,1,0,1-0.9,1c-0.9,0-1.8,0.1-2.7,0c-0.7,0-0.8,0.2-0.8,0.8c0,1.1,0,2.2,0,3.3 c0,0.4-0.1,0.6-0.5,0.6c-1,0-1,0-1-1c0-1,0-2,0-3c0-0.5-0.1-0.7-0.6-0.7c-1.1,0.1-2.2,0-3.2,0c-0.4,0-0.6-0.1-0.5-0.5 c0-0.2,0-0.3,0-0.5c-0.1-0.4,0.1-0.5,0.5-0.5c1.3,0,2.6,0,3.9,0c0.3,0,0.2-0.3,0.2-0.5c0-1.1,0-2.2,0-3.3 C74.6,41.3,74.7,41.1,74.4,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M15.9,53.3c0.2-1,0.1-2,0.1-3c0-0.6,0.1-0.8,0.8-0.8c0.8,0.1,1.7,0,2.6,0c0.3,0,0.5,0,0.5,0.4 c0,1.1,0,2.1,0,3.2c0,0,0,0,0,0c-0.7,0-1.3,0-2,0c-0.6,0-1.1-0.1-1.7,0.1l0,0c0,0.1,0,0.2,0,0.2c-0.1,0.8-0.1,1.6,0,2.4 c0,0.1,0,0.1,0,0.2c-0.9,0-1.9,0-2.8,0c0,0,0-0.1,0-0.1c0-0.9,0-1.7,0-2.6c0,0,0,0,0-0.1C14.1,53.3,15,53.3,15.9,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M103.2,36c-1.7,0-1.7,0-1.7-1.7c0-1.5,0-1.5,1.5-1.5c0.5,0,1,0,1.5,0c0.4,0,0.6,0.1,0.6,0.5c0,0.7,0,1.5,0,2.2 c0,0.4-0.2,0.5-0.5,0.5C104.1,36,103.7,36,103.2,36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M97.4,43.5c-0.1-0.9,0-1.8-0.1-2.7c0-0.3,0.2-0.4,0.4-0.4c0.9,0,1.7,0,2.6,0c0.3,0,0.5,0.1,0.5,0.4 c0,0.9,0.1,1.7,0,2.6C99.7,43.5,98.6,43.5,97.4,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M89.1,43.5c-0.2-0.9,0-1.8-0.1-2.7c0-0.3,0.2-0.4,0.4-0.4c0.9,0,1.8,0,2.6,0c0.7,0,0.4,0.6,0.4,1 c-0.2,0.5-0.1,0.9-0.1,1.4c0,0.5-0.1,0.7-0.7,0.7C90.9,43.5,90,43.5,89.1,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M93.2,43.5c0-0.9,0-1.7,0-2.6c0-0.2,0.1-0.4,0.3-0.4c1,0,1.9,0,2.9,0c0.1,0,0.2,0.1,0.2,0.2c0,0.8,0,1.5,0,2.3 c0,0.5-0.2,0.6-0.6,0.6C95.1,43.5,94.2,43.5,93.2,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M105.7,43.5c0-0.9,0-1.7,0-2.6c0-0.3,0.1-0.5,0.4-0.5c1,0,1.9,0,2.9,0c0.1,0,0.2,0.1,0.2,0.2 c0,0.8,0,1.5,0,2.3c0,0.4-0.1,0.6-0.5,0.5C107.6,43.5,106.7,43.5,105.7,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.2,39.6c0-0.8,0-1.7,0-2.5c0-0.2,0.1-0.5,0.4-0.5c1,0,1.9,0,2.9,0c0.1,0,0.2,0.1,0.2,0.2 c0,0.7-0.1,1.5,0,2.2c0,0.5-0.1,0.7-0.7,0.7c-0.9,0-1.8,0-2.7,0c0,0,0,0,0,0C93.3,39.7,93.2,39.6,93.2,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M97.4,39.6c0-0.8,0-1.6,0-2.4c0-0.3,0.1-0.5,0.4-0.5c0.9,0,1.9,0,2.8,0c0.1,0,0.2,0.1,0.3,0.2 c0,0.8,0,1.5,0,2.3c0,0.2,0,0.5-0.3,0.5C99.4,39.7,98.4,39.8,97.4,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.5,43.5c0-0.9,0-1.7,0-2.6c0-0.2,0.1-0.5,0.4-0.5c1,0,2-0.1,3,0.1c0,0.9,0,1.9,0,2.8 c-0.1,0.1-0.3,0.1-0.4,0.1C103.4,43.5,102.5,43.5,101.5,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M101.5,39.6c0-0.8,0-1.7,0-2.5c0-0.3,0.1-0.5,0.4-0.4c1,0,2-0.1,3,0.1c0,1,0,1.9,0,2.9 c-0.2,0.2-0.4,0.1-0.6,0.1c-0.9,0-1.7,0-2.6,0c0,0,0,0,0,0C101.6,39.7,101.6,39.6,101.5,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M62.4,53.6c-1,0-1.6-0.5-2.1-1.4c-0.1-0.2-0.2-0.5-0.5-0.5c-0.2,0-0.3-0.2-0.3-0.4c0-0.2,0.1-0.3,0.3-0.3 c0.3,0,0.3-0.2,0.4-0.4c0.5-1.1,1.4-1.7,2.5-1.5c1,0.1,1.8,1,1.9,2.1C64.8,52.5,63.7,53.6,62.4,53.6z M62.4,52.9 c0.9,0,1.6-0.7,1.6-1.5c0-0.8-0.7-1.5-1.5-1.6c-0.9,0-1.6,0.7-1.6,1.6C60.8,52.2,61.5,52.9,62.4,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M10.7,53.1c0-0.6,0-1.3,0-1.9c0-0.2,0.1-0.4,0.3-0.3c0.7,0,1.4-0.1,2.1,0.1c0,0.5,0,1.1,0,1.6 c0,0.4-0.1,0.6-0.6,0.6C11.9,53.1,11.3,53.1,10.7,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M91.1,55.7c0.8,0.2,1.6,0.6,2.4,0.7c2.7,0.6,5.4,0.6,8.1,0.2c2.2-0.3,4.2-1.1,6.1-2.2 c0.2-0.1,0.4-0.3,0.6-0.2c-1.1,0.9-2.4,1.4-3.7,1.9c-4.1,1.3-8.2,1.4-12.3,0.2C91.9,56.2,91.4,56.1,91.1,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M16.2,42.4c0.7-0.8,1.6-1,2.6-1.2c1.4-0.2,2.8,0,4.1,0.8c0.2,0.1,0.4,0.2,0.5,0.4c-0.8-0.4-1.7-0.9-2.7-1 c-1.5-0.2-2.9,0-4.2,0.8C16.5,42.3,16.4,42.5,16.2,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76,45.3c-0.3-0.1-0.2-0.3-0.2-0.5c0-1,0-2.1,0-3.1c0-0.8,0-0.8-0.8-0.8c-0.2,0-0.3,0-0.5,0 c0.4-0.5,0.9-0.2,1.3-0.2c0.3,0,0.2,0.4,0.2,0.6C75.9,42.7,76,44,76,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105.7,43.5c1,0,1.9,0,2.9,0c0.4,0,0.5-0.2,0.5-0.5c0-0.8,0-1.5,0-2.3c0.2,0.9,0,1.8,0.1,2.7 c0,0.2-0.1,0.4-0.3,0.4c-1,0-1.9,0-2.9,0C105.8,43.7,105.7,43.6,105.7,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93.2,43.5c0.9,0,1.9,0,2.8,0c0.4,0,0.6-0.1,0.6-0.6c0-0.7,0-1.5,0-2.3c0.2,0.9,0,1.8,0.1,2.7 c0,0.2-0.1,0.4-0.4,0.4c-0.9,0-1.9,0-2.8,0C93.4,43.7,93.3,43.7,93.2,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93.3,39.7c0.9,0,1.8,0,2.7,0c0.5,0,0.7-0.2,0.7-0.7c0-0.7,0-1.5,0-2.2c0.2,0.9,0,1.8,0.1,2.7 c0,0.2-0.1,0.4-0.3,0.4C95.4,39.9,94.4,39.9,93.3,39.7C93.3,39.8,93.3,39.8,93.3,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.1,43.5c0.9,0,1.8,0,2.7,0c0.6,0,0.7-0.2,0.7-0.7c0-0.5-0.1-0.9,0.1-1.4c0,0.6,0,1.2,0,1.8 c0,0.2,0,0.5-0.3,0.5c-1,0-2,0-3,0C89.2,43.7,89.2,43.6,89.1,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10,47.1c1.1,0,2.1,0,3.2,0c0.3,0,0.4-0.1,0.4-0.4c0.1-0.7,0.3-1.4,0.6-2.1c0.1-0.2,0.1-0.4,0.4-0.4 c-0.4,0.9-0.8,1.8-0.8,2.8c0,0.2-0.1,0.3-0.3,0.3c-1.1,0-2.3,0-3.4,0C10,47.3,10,47.2,10,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M74.4,41c0.2,0.1,0.2,0.3,0.2,0.5c0,1.1,0,2.2,0,3.3c0,0.2,0.1,0.4-0.2,0.5c0-1.2,0-2.4,0-3.6 C74.4,41.5,74.4,41.3,74.4,41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M19.8,56.9c1.5,0,3-0.3,4.3-1c0.2-0.1,0.3-0.2,0.5-0.2c-0.8,0.7-1.7,0.9-2.7,1.2c-0.6,0.2-1.2,0.2-1.8,0.2 C20,57.1,19.8,57.2,19.8,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M101.5,43.5c0.9,0,1.9,0,2.8,0c0.2,0,0.3,0,0.4-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1,0.3,0,0.6-0.4,0.6 c-0.9,0-1.9,0-2.8,0C101.7,43.7,101.6,43.7,101.5,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M10.7,53.1c0.6,0,1.2,0,1.8,0c0.5,0,0.6-0.2,0.6-0.6c0-0.5,0-1.1,0-1.6c0.2,0.8,0,1.5,0.1,2.3 c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1c0,0,0,0,0,0c-0.6,0-1.3,0-1.9,0C11,53.3,10.7,53.5,10.7,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M97.4,39.6c1,0.2,2.1,0.1,3.1,0.1c0.3,0,0.3-0.3,0.3-0.5c0-0.8,0-1.5,0-2.3c0.2,0.9,0,1.8,0.1,2.7 c0,0.2-0.1,0.4-0.4,0.4c-0.9,0-1.9,0-2.8,0C97.5,39.9,97.4,39.8,97.4,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M97.4,43.5c1.1,0,2.3,0,3.4,0c-0.1,0.2-0.2,0.2-0.4,0.2c-0.9,0-1.7,0-2.6,0C97.7,43.7,97.5,43.7,97.4,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M101.6,39.7c0.9,0,1.7,0,2.6,0c0.2,0,0.5,0.1,0.6-0.1c0.2-0.2,0.1-0.4,0.1-0.6c0-0.7,0-1.4,0-2.1 c0.2,0.9,0,1.8,0.1,2.7c0,0.2-0.1,0.3-0.2,0.3C103.7,39.8,102.7,40,101.6,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55.5,53.3c1.1,0.5,2.1,0,3-0.6C57.8,53.7,56.5,54,55.5,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M61.3,48.2c0.9,0.4,1.8,0.2,2.6-0.3C63.2,48.7,62.1,48.8,61.3,48.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105,43.1c-0.1,0.1-0.1,0.2-0.2,0.3c0-0.9,0-1.9,0-2.8c0,0,0.1,0.1,0.1,0.1c0,0.2-0.1,0.4,0,0.6 c0,0.5,0,1,0,1.5c0,0,0,0,0,0c0,0,0,0.1,0,0.1C105,43,105,43,105,43.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M114.7,45.6c0.3-0.3,0.7-0.1,1-0.2c0.6-0.1,1.1-0.3,1.7-0.3c-0.6,0.4-1.3,0.4-2,0.5 C115.2,45.6,115,45.6,114.7,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55.6,48.3c0.9,0.3,1.7,0.1,2.5-0.4C57.5,48.6,56.6,48.8,55.6,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M16,53.3c0.5-0.2,1.1-0.1,1.7-0.1c0.7,0,1.3,0,2,0c0,0,0,0.1,0,0.1c-0.2,0-0.4,0-0.5,0c0,0-0.1,0-0.1,0 c-0.1,0-0.2,0-0.3,0c-0.4,0-0.8,0-1.1,0C17.1,53.3,16.5,53.3,16,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M58.6,47.2c0.2-0.8,0.7-1.1,1.5-0.6c-0.1,0-0.2,0.1-0.4,0C59.2,46.5,58.8,46.7,58.6,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M13.1,56.1c0.9,0,1.9,0,2.8,0c0,0.2-0.1,0.2-0.3,0.2c-0.8,0-1.5,0-2.3,0C13.3,56.2,13.1,56.2,13.1,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M105,36.9c0,0.7,0,1.4,0,2.1c0,0.2,0.1,0.4-0.1,0.6c0-1,0-1.9,0-2.9C104.9,36.8,104.9,36.8,105,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M13.1,53.3c0,0,0-0.1,0-0.1c0.9,0.1,1.9-0.1,2.8,0.1C15,53.3,14.1,53.3,13.1,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M108.7,54c0.2-0.5,0.6-0.8,1.1-0.9C109.5,53.5,109.2,53.8,108.7,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M110.1,52.9c0.2-0.5,0.5-0.8,1-1C110.8,52.3,110.5,52.7,110.1,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M13.1,53.4C13.1,53.4,13.1,53.4,13.1,53.4c0,0.9,0,1.7,0,2.6C13,55.1,13,54.2,13.1,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M16,55.9c-0.1-0.8-0.1-1.6,0-2.4C16.1,54.3,16.1,55.1,16,55.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117.9,44.9c0.3-0.3,0.6-0.6,1-0.7C118.7,44.5,118.3,44.8,117.9,44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119.6,43.3c0-0.4,0.2-0.7,0.4-1C120,42.7,119.9,43,119.6,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M16,53.3c0.5,0,1,0,1.5,0C17.1,53.4,16.5,53.4,16,53.3C16,53.3,16,53.3,16,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M58.5,52.7c0-0.3,0.2-0.6,0.4-0.9C58.8,52.1,58.7,52.4,58.5,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M21.6,53c-0.2,0.1-0.4,0.2-0.7,0.2C21.1,52.9,21.4,53,21.6,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M14.9,43.8c0-0.3,0.1-0.4,0.4-0.5C15.2,43.5,15.1,43.7,14.9,43.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M24.6,55.7c0.1-0.3,0.3-0.3,0.6-0.4C25.1,55.6,24.9,55.7,24.6,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M20.6,53.2c-0.2,0.1-0.5,0.1-0.7,0.1C20.1,53.2,20.4,53.2,20.6,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M15.8,42.8c0-0.2,0.1-0.4,0.4-0.3C16.2,42.6,16,42.7,15.8,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.5,47.1c0-0.2-0.1-0.4,0.1-0.6C64.7,46.7,64.6,46.9,64.5,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M14.6,44.2c0-0.2,0-0.4,0.3-0.5C14.9,44,14.7,44.1,14.6,44.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26.7,54.1c0.1-0.2,0.1-0.4,0.4-0.4C27,54,26.9,54.1,26.7,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26.1,54.7c0-0.2,0.1-0.4,0.4-0.4C26.4,54.6,26.3,54.7,26.1,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M117.4,45.1c0.1-0.2,0.3-0.3,0.5-0.2C117.8,45.1,117.6,45.1,117.4,45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105,41.3c-0.1-0.2-0.1-0.4,0-0.6C105.1,40.9,105,41.1,105,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M15.2,43.3c0-0.2,0.2-0.3,0.4-0.4C15.6,43.1,15.4,43.2,15.2,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64,47.8c0-0.2,0.1-0.3,0.3-0.4C64.3,47.6,64.2,47.8,64,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90.4,55.4c0.2,0,0.4,0,0.4,0.2C90.6,55.6,90.5,55.5,90.4,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111.3,51.7c0-0.2,0-0.4,0.3-0.4C111.6,51.5,111.4,51.6,111.3,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M108.4,54.3c0-0.3,0.2-0.3,0.4-0.2C108.6,54.1,108.5,54.2,108.4,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119.4,43.6c0-0.2,0.1-0.3,0.2-0.4C119.6,43.4,119.5,43.5,119.4,43.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M24.3,43.3c0.2,0,0.3,0.2,0.3,0.3C24.5,43.6,24.4,43.4,24.3,43.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111.5,51.3c0-0.1,0-0.2,0.2-0.3C111.7,51.2,111.7,51.3,111.5,51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119.1,43.9c0-0.2,0.1-0.3,0.2-0.3C119.3,43.8,119.3,43.9,119.1,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M19.2,53.3c0.2,0,0.4,0,0.5,0c0,0,0,0.1,0,0.1C19.6,53.4,19.4,53.4,19.2,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M27.1,53.8c0-0.2,0.1-0.3,0.3-0.3C27.3,53.6,27.2,53.7,27.1,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M25.7,55c0-0.2,0.2-0.3,0.4-0.2C26,54.9,25.9,55,25.7,55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M58.2,47.8c0-0.2,0.1-0.3,0.2-0.3C58.5,47.7,58.4,47.8,58.2,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.1,54.3c0.2,0,0.2,0.1,0.3,0.3C89.2,54.5,89.2,54.4,89.1,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.6,42.6c0.2,0,0.2,0.1,0.3,0.2C23.7,42.8,23.6,42.7,23.6,42.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.5,54.6c0.1,0,0.2,0.1,0.3,0.2C89.6,54.9,89.5,54.8,89.5,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90.8,55.6c0.1,0,0.3,0,0.4,0.1C91,55.8,90.8,55.7,90.8,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M61,48c0.1,0,0.2,0,0.2,0.1C61.2,48.2,61.1,48.1,61,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M58.5,47.5c0-0.1,0-0.2,0.1-0.3C58.6,47.4,58.6,47.5,58.5,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.4,47.3c0-0.1,0-0.2,0.1-0.3C64.5,47.1,64.5,47.2,64.4,47.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M15.6,42.9c0-0.1,0.1-0.2,0.2-0.2C15.8,42.9,15.7,42.9,15.6,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55.3,53.2c0.1,0,0.2,0,0.2,0.1C55.4,53.3,55.3,53.3,55.3,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M27.6,53.2c0-0.1,0-0.2,0.1-0.2C27.7,53.1,27.7,53.1,27.6,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M18.7,53.3c0.1,0,0.2,0,0.3,0C18.9,53.4,18.8,53.4,18.7,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.4,42.4c0.1,0,0.2,0,0.2,0.2C23.5,42.6,23.4,42.5,23.4,42.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90,55.1c0.1,0,0.2,0,0.2,0.1C90.1,55.3,90.1,55.2,90,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M25.4,55.2c0-0.1,0.1-0.2,0.2-0.1C25.6,55.2,25.5,55.3,25.4,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M27.7,52.9c0-0.1,0-0.1,0.1-0.1C27.8,52.9,27.8,52.9,27.7,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54.9,52.8c0,0,0.1,0.1,0.1,0.1C55,52.9,55,52.8,54.9,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M24.2,43.2c0.1,0,0.1,0.1,0.1,0.1C24.3,43.2,24.3,43.2,24.2,43.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55,52.9c0,0,0.1,0.1,0.1,0.1C55.1,53,55.1,53,55,52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109.9,53c0-0.1,0-0.1,0.1-0.1C110,52.9,110,53,109.9,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M55.2,53c0,0,0.1,0.1,0.1,0.1C55.3,53.1,55.2,53.1,55.2,53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M109.8,53.1c0-0.1,0-0.1,0.1-0.1C109.9,53.1,109.9,53.1,109.8,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M24,42.9c0.1,0,0.1,0,0.1,0.1C24.1,43,24,43,24,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M105,42.9C105,42.9,105,42.8,105,42.9c0-0.1,0-0.1,0-0.1C105,42.8,105,42.8,105,42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M23.9,42.8c0.1,0,0.1,0.1,0.1,0.1C23.9,42.9,23.9,42.8,23.9,42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M24.1,43c0.1,0,0.1,0,0.1,0.1C24.2,43.1,24.1,43.1,24.1,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M27.3,53.4c0-0.1,0-0.1,0.1-0.1C27.5,53.4,27.4,53.4,27.3,53.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M101.5,39.6c0,0,0.1,0.1,0.1,0.1C101.5,39.7,101.5,39.7,101.5,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93.2,39.6c0,0,0.1,0.1,0.1,0.1C93.2,39.7,93.2,39.7,93.2,39.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M88.8,53.9c0,0,0.1,0.1,0.1,0.1C88.9,54,88.8,53.9,88.8,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M88.9,54c0.1,0,0.1,0,0.1,0.1C88.9,54.1,88.9,54.1,88.9,54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M60.7,47.7c0,0,0.1,0.1,0.1,0.1C60.7,47.8,60.7,47.7,60.7,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26.6,54.3c0-0.1,0-0.1,0.1-0.1C26.7,54.2,26.7,54.3,26.6,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89,54.1c0,0,0.1,0.1,0.1,0.1C89.1,54.3,89,54.2,89,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M26.5,54.4c0-0.1,0-0.1,0.1-0.1C26.6,54.3,26.5,54.4,26.5,54.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M27.4,53.3c0-0.1,0-0.1,0.1-0.1C27.6,53.2,27.5,53.3,27.4,53.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M58.1,47.9c0,0,0.1-0.1,0.1-0.1C58.2,47.9,58.2,47.9,58.1,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.4,54.5c0.1,0,0.1,0,0.1,0.1C89.5,54.6,89.4,54.6,89.4,54.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M118.9,44.1c0,0,0.1-0.1,0.1-0.1C119,44.1,119,44.1,118.9,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M119,44c0,0,0.1-0.1,0.1-0.1C119.1,44,119.1,44,119,44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.8,54.9c0,0,0.1,0.1,0.1,0.1C89.8,55,89.8,55,89.8,54.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M25.6,55.1c0-0.1,0-0.1,0.1-0.1C25.7,55.1,25.7,55.1,25.6,55.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M89.9,55c0,0,0.1,0.1,0.1,0.1C90,55.1,89.9,55,89.9,55z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M60.6,47.5c0,0,0.1,0.1,0.1,0.1C60.6,47.6,60.6,47.6,60.6,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M60.8,47.8c0,0,0.1,0.1,0.1,0.1C60.9,47.9,60.8,47.8,60.8,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M25.2,55.4c0-0.1,0.1-0.1,0.1-0.1C25.4,55.3,25.3,55.4,25.2,55.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M90.3,55.2c0,0,0.1,0.1,0.1,0.1C90.3,55.4,90.3,55.3,90.3,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M63.9,47.9c0,0,0.1-0.1,0.1-0.1C64,47.9,64,47.9,63.9,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M111,51.9c0-0.1,0.1-0.1,0.2-0.1C111.1,51.8,111.1,51.9,111,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M27.8,52.8c0-0.1,0.1-0.1,0.1-0.1C27.9,52.7,27.9,52.8,27.8,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M60.9,47.9c0,0,0.1,0.1,0.1,0.1C61,48,60.9,48,60.9,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M64.2,47.4c0,0,0.1-0.1,0.1-0.1C64.4,47.4,64.3,47.4,64.2,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M19.8,56.7C19.8,56.7,19.8,56.8,19.8,56.7c0,0.1,0,0.1,0,0.1C19.8,56.8,19.8,56.8,19.8,56.7 C19.7,56.7,19.8,56.7,19.8,56.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M52.5,38.9c1.4,0,2.5,1.2,2.5,2.5c0,1.4-1.2,2.5-2.6,2.5c-1.4,0-2.5-1.2-2.5-2.6C49.9,40,51.1,38.9,52.5,38.9 z M51.2,41.4C51.2,41.4,51.2,41.4,51.2,41.4c0,0.4,0,0.7,0,1.1c0.1,0.4,0.3,0.7,0.8,0.5c0.7-0.3,1.3-0.7,1.9-1.1 c0.4-0.3,0.3-0.7-0.1-1c-0.5-0.3-1-0.7-1.6-1c-0.5-0.3-1,0-1,0.6C51.2,40.8,51.2,41.1,51.2,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M56.6,49.8c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6c-0.8,0-1.6-0.7-1.6-1.6C55,50.6,55.7,49.8,56.6,49.8 z M56.3,51.4c0-0.1-0.1-0.3-0.3-0.3c-0.2,0-0.3,0.1-0.3,0.3c0,0.2,0.1,0.3,0.3,0.3C56.2,51.7,56.3,51.6,56.3,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M55,46.3c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6c0,0.9-0.7,1.6-1.6,1.6C55.8,47.9,55.1,47.2,55,46.3z  M57.6,45.8c-0.1-0.2-0.2-0.3-0.4-0.2c-0.1,0-0.2,0.1-0.3,0.2c-0.3,0.2-0.5,0.7-1,0.3c-0.1-0.1-0.2,0-0.3,0.1 c-0.1,0.1-0.1,0.2,0,0.3c0.3,0.6,0.8,0.7,1.3,0.3c0.2-0.2,0.4-0.4,0.6-0.6C57.5,46,57.6,46,57.6,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M62.4,44.7c0.9,0,1.6,0.7,1.5,1.6c0,0.9-0.8,1.6-1.6,1.5c-0.9,0-1.6-0.8-1.5-1.6 C60.8,45.3,61.6,44.7,62.4,44.7z M62.9,46.4c0,0,0.1-0.1,0.1-0.1l0,0c0.2-0.2,0.5-0.3,0.3-0.6c-0.3-0.4-0.5,0-0.7,0.2 c-0.3,0.2-0.4,0.6-0.9,0.2c-0.1-0.1-0.2,0-0.3,0.1c-0.1,0.1-0.1,0.3,0,0.4c0.1,0.2,0.3,0.3,0.4,0.4c0.3,0.4,0.6,0.2,0.8-0.1 c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0C62.8,46.5,62.8,46.5,62.9,46.4 C62.9,46.4,62.9,46.4,62.9,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M62.4,52.9c-0.9,0-1.6-0.7-1.6-1.5c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.5,0.7,1.5,1.6C64,52.3,63.3,52.9,62.4,52.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.2,41.4c0-0.3,0-0.6,0-0.9c0.1-0.6,0.5-0.9,1-0.6c0.5,0.3,1,0.6,1.6,1c0.4,0.3,0.5,0.7,0.1,1 c-0.6,0.4-1.2,0.8-1.9,1.1c-0.5,0.2-0.7-0.1-0.8-0.5C51.2,42.2,51.2,41.8,51.2,41.4C51.2,41.4,51.2,41.4,51.2,41.4z M53.4,41.5 c-0.5-0.4-1-0.7-1.6-1c0,0.6,0,1.1,0,1.6c0,0.2,0.1,0.3,0.3,0.2C52.6,42,53,41.8,53.4,41.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M56.3,51.4c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C56.2,51.1,56.3,51.2,56.3,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.6,45.8c0,0.2-0.1,0.3-0.2,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.5,0.5-1,0.4-1.3-0.3c0-0.1-0.1-0.2,0-0.3 c0.1-0.1,0.2-0.2,0.3-0.1c0.5,0.4,0.7,0,1-0.3c0.1-0.1,0.2-0.2,0.3-0.2C57.4,45.5,57.5,45.6,57.6,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61.7,46.9c-0.1-0.1-0.3-0.3-0.4-0.4c-0.1-0.1-0.1-0.3,0-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0.4,0.4,0.6,0,0.9-0.2 c0.2-0.2,0.4-0.6,0.7-0.2c0,0.2-0.3,0.4-0.3,0.6c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0 c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0C62.3,46.8,62,47,61.7,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M61.7,46.9c0.3,0.1,0.5-0.1,0.8-0.1C62.3,47.1,62.1,47.4,61.7,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M63,46.3c0-0.3,0.3-0.4,0.3-0.6C63.5,46,63.2,46.2,63,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.5,46.8c0,0,0.1-0.1,0.1-0.1C62.6,46.7,62.6,46.8,62.5,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.6,46.7c0,0,0.1-0.1,0.1-0.1C62.7,46.6,62.7,46.6,62.6,46.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.8,46.6c0,0,0.1-0.1,0.1-0.1C62.8,46.5,62.8,46.5,62.8,46.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M62.9,46.4c0,0,0.1-0.1,0.1-0.1C63,46.3,62.9,46.4,62.9,46.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M53.4,41.5c-0.5,0.3-0.9,0.5-1.3,0.8c-0.2,0.1-0.3,0-0.3-0.2c0-0.5,0-1,0-1.6C52.4,40.8,52.9,41.1,53.4,41.5z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalOceanContainer);
export default __webpack_public_path__ + "static/media/DigitalOceanContainer.154be4305d7eb9f848b52e2e78e3e3c0.svg";
export { ForwardRef as ReactComponent };